import React from 'react';
import { cn } from './cn';

// Elevated surface used for cards, chart panels, KPI tiles.
const Card = ({ className, hover = false, children, ...props }) => (
  <div
    className={cn(
      'rounded-2xl bg-surface border border-border shadow-md',
      hover && 'transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5',
      className
    )}
    {...props}
  >
    {children}
  </div>
);

export default Card;
